import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input
} from '@angular/core';
import { UserType } from '@libs/apis';
import { AiCampaignsViewService } from '../../services/ai-campaigns-view.service';
import { CampaignAccordionService } from '../../services/campaign-accordion.service';
import { CampaignTableService } from '../../services/campaign-table.service';
import { CampaignsConfirmationPopupService } from '../../services/campaigns-confirmation-popup.service';
import { CampaignsGlobalLoaderService } from '../../services/campaigns-global-loader.service';

@Component({
  selector: 'lib-taxonomy-ai-campaigns-view',
  templateUrl: './ai-campaigns-view.component.html',
  styleUrls: ['./ai-campaigns-view.component.scss'],
  standalone: false
})
export class AiCampaignsViewComponent {
  clientId = input(0);
  brandId = input(0);
  userType = input<UserType>(UserType.external);

  readonly aiCampaignsViewService = inject(AiCampaignsViewService);
  readonly campaignAccordionService = inject(CampaignAccordionService);
  readonly campaignTableService = inject(CampaignTableService);
  readonly campaignsGlobalLoaderService = inject(CampaignsGlobalLoaderService);
  readonly campaignsConfirmationPopupService = inject(
    CampaignsConfirmationPopupService
  );

  readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this.aiCampaignsViewService.clientId = this.clientId();
      this.aiCampaignsViewService.brandId = this.brandId();
      this.aiCampaignsViewService.userType = this.userType();
      this.aiCampaignsViewService.initializeComponent().then(() => {
        this.cdr.detectChanges();
      });
    });
  }
}
